@import 'common/component';
@import 'forms/reset/button';
@import '../../../foundation/src/lib/scss/settings/variables';
@import '../../../foundation/src/lib/scss/settings/mixins';
@import '../../../foundation/src/lib/scss/design-tokens/design-tokens';

:host {
  display: inline-block;
}

:host([disabled]) {
  pointer-events: none;
}

// TODO: Remove this block attribute styles when the deprecated block attribute is removed
:host([block='false']) {
  display: inline-block;
}

:host([block]),
:host([block='true']) {
  display: block;
}

:host([full-width='false']) {
  display: inline-block;
}

:host([full-width]),
:host([full-width='true']) {
  display: block;
}

.o2-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--o2-spacing-sm, #{$spacing-sm});
  vertical-align: top;
  height: var(--o2-component-default-height, #{$component-default-height});
  min-height: var(--o2-component-default-height, #{$component-default-height});
  padding: 0 var(--o2-spacing-lg, #{$spacing-lg});
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  font-size: var(--o2-font-size-base, #{$font-size-base});
  @include font-weight(600);
  text-align: center;
  line-height: var(--o2-line-height-base, #{$line-height-base});
  text-decoration: none;
  border-radius: var(--o2-radius-xs, #{$radius-xs});
  flex-shrink: 0;
  transition-property: color, background-color, border-color;
  transition-duration: 0.2s;
  transition-timing-function: var(--o2-transition);
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    @include focus-visible();
  }

  &.o2-button--disabled {
    opacity: var(--o2-opacity-disabled, #{$opacity-disabled * 1%});
    cursor: not-allowed;
  }

  &.o2-button--full-width {
    display: flex;
    width: 100%;
  }
}

.o2-button--filled {
  border: 0.1rem solid transparent;
  background-clip: border-box;

  &.o2-button--primary {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});
    background-color: var(--o2-button-primary, #{$button-primary});

    &:hover {
      color: var(--o2-text-main-on-color, #{$text-main-on-color});
      background-color: var(--o2-button-primary-hover, mix($black, $button-primary, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-primary-focus, mix($black, $button-primary, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-primary-active, mix($black, $button-primary, $opacity-active * 1%));
    }
  }

  &.o2-button--secondary {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});
    background-color: var(--o2-button-secondary, #{$button-secondary});

    &:hover {
      color: var(--o2-text-main-on-color, #{$text-main-on-color});
      background-color: var(--o2-button-secondary-hover, mix($black, $button-secondary, $opacity-hover * 1%));
    }

    &:focus  {
      background-color: var(--o2-button-secondary-focus, mix($black, $button-secondary, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-secondary-active, mix($black, $button-secondary, $opacity-active * 1%));
    }
  }

  &.o2-button--danger {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});
    background-color: var(--o2-button-danger, #{$button-danger});

    &:hover {
      color: var(--o2-text-main-on-color, #{$text-main-on-color});
      background-color: var(--o2-button-danger-hover, mix($black, $button-danger, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-danger-focus, mix($black, $button-danger, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-danger-active, mix($black, $button-danger, $opacity-active * 1%));
    }
  }

  &.o2-button--inverted {
    color: var(--o2-text-main-action, #{$text-main-action});
    background-color: var(--o2-button-inverted, #{$button-inverted});

    &:hover {
      color: var(--o2-text-main-action, #{$text-main-action});
      background-color: var(--o2-button-inverted-hover, mix($black, $button-inverted, $opacity-hover * 1%));
    }

    &:focus{
      background-color: var(--o2-button-inverted-focus, mix($black, $button-inverted, $opacity-focus * 1%));
    }

    &:focus-visible {
      @include focus-visible($outline-on-color);
    }

    &:active {
      background-color: var(--o2-button-inverted-active, mix($black, $button-inverted, $opacity-active * 1%));
    }
  }
}

.o2-button--outlined {
  border: 0.1rem solid var(--o2-border-primary, #{$border-primary});
  background-color: transparent;
  background-clip: padding-box;

  &.o2-button--primary {
    color: var(--o2-text-main-action, #{$text-main-action});

    &:hover {
      color: var(--o2-text-main-action, #{$text-main-action});
      background-color: var(--o2-button-dark-opacity-hover, hsla(0, 0%, 0%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-dark-opacity-focus, hsla(0, 0%, 0%, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-dark-opacity-active, hsla(0, 0%, 0%, $opacity-active * 1%));
    }
  }

  &.o2-button--danger {
    color: var(--o2-text-main-error, #{$text-main-error});

    &:hover {
      color: var(--o2-text-main-error, #{$text-main-error});
      background-color: var(--o2-button-dark-opacity-hover, hsla(0, 0%, 0%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-dark-opacity-focus, hsla(0, 0%, 0%, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-dark-opacity-active, hsla(0, 0%, 0%, $opacity-active * 1%));
    }
  }

  &.o2-button--inverted {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});

    &:hover {
      color: var(--o2-text-main-on-color, #{$text-main-on-color});
      background-color: var(--o2-button-light-opacity-hover, hsla(0, 0%, 100%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-light-opacity-focus, hsla(0, 0%, 100%, $opacity-focus * 1%));
    }

    &:focus-visible {
      @include focus-visible($outline-on-color);
    }

    &:active {
      background-color: var(--o2-button-light-opacity-active, hsla(0, 0%, 100%, $opacity-active * 1%));
    }
  }
}

.o2-button--ghost {
  border: 0.1rem solid transparent;
  background-color: transparent;
  background-clip: border-box;

  &.o2-button--primary {
    color: var(--o2-text-main-action, #{$text-main-action});

    &:hover {
      color: var(--o2-text-main-action, #{$text-main-action});
      background-color: var(--o2-button-dark-opacity-hover, hsla(0, 0%, 0%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-dark-opacity-focus, hsla(0, 0%, 0%, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-dark-opacity-active, hsla(0, 0%, 0%, $opacity-active * 1%));
    }
  }

  &.o2-button--danger {
    color: var(--o2-text-main-error, #{$text-main-error});

    &:hover {
      color: var(--o2-text-main-error, #{$text-main-error});
      background-color: var(--o2-button-dark-opacity-hover, hsla(0, 0%, 0%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-dark-opacity-focus, hsla(0, 0%, 0%, $opacity-focus * 1%));
    }

    &:active {
      background-color: var(--o2-button-dark-opacity-active, hsla(0, 0%, 0%, $opacity-active * 1%));
    }
  }

  &.o2-button--inverted {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});

    &:hover {
      color: var(--o2-text-main-on-color, #{$text-main-on-color});
      background-color: var(--o2-button-light-opacity-hover, hsla(0, 0%, 100%, $opacity-hover * 1%));
    }

    &:focus {
      background-color: var(--o2-button-light-opacity-focus, hsla(0, 0%, 100%, $opacity-focus * 1%));
    }

    &:focus-visible {
      @include focus-visible($outline-on-color);
    }

    &:active {
      background-color: var(--o2-button-light-opacity-active, hsla(0, 0%, 100%, $opacity-active * 1%));
    }
  }
}

.o2-button--text {
  border: 0;
  padding: 0;
  background-color: transparent;
  background-clip: border-box;
  min-height: auto;
  height: auto;
  gap: var(--o2-spacing-xs, #{$spacing-xs});

  &.o2-button--primary {
    color: var(--o2-text-main-action, #{$text-main-action});

    &:hover {
      color: var(--o2-text-main-action-hover, mix($black, $text-main-action, $opacity-hover * 1%));
    }

    &:focus {
      color: var(--o2-text-main-action-focus, mix($black, $text-main-action, $opacity-focus * 1%));
    }

    &:active {
      color: var(--o2-text-main-action-active, mix($black, $text-main-action, $opacity-active * 1%));
    }
  }

  &.o2-button--danger {
    color: var(--o2-text-main-error, #{$text-main-error});

    &:hover {
      color: var(--o2-text-main-error-hover, mix($black, $text-main-error, $opacity-hover * 1%));
    }

    &:focus {
      color: var(--o2-text-main-error-focus, mix($black, $text-main-error, $opacity-focus * 1%));
    }

    &:active {
      color: var(--o2-text-main-error-active, mix($black, $text-main-error, $opacity-active * 1%));
    }
  }

  &.o2-button--inverted {
    color: var(--o2-text-main-on-color, #{$text-main-on-color});

    &:hover {
      color: var(--o2-text-main-on-color-hover, mix($black, $text-main-on-color, $opacity-hover * 1%));
    }

    &:focus {
      color: var(--o2-text-main-on-color-focus, mix($black, $text-main-on-color, $opacity-focus * 1%));
    }

    &:focus-visible {
      @include focus-visible($outline-on-color);
    }

    &:active {
      color: var(--o2-text-main-on-color-active, mix($black, $text-main-on-color, $opacity-active * 1%));
    }
  }
}

::slotted(o2-icon) {
  transition: none !important;
}
